// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* スイッチ全体のスタイル */
.switch {
  position: relative;
  width: fit-content;
  height: 42px;
  background-color: var(--white-color-light);
  border-radius: 4px;
  padding: 0px 4px;
  --item-width: 40px;
  --item-height: 40px;
  --cursor-index: 2;
  /* 背後のカーソル */
  /* アイコンのスタイル */
}
.switch.disabled {
  background-color: var(--disabled-bg-color);
  color: var(--disabled-font-color);
  cursor: default;
}
.switch.disabled .cursor {
  background-color: var(--disabled-border-color);
}
.switch .cursor {
  position: absolute;
  top: 4px;
  left: 2px;
  width: calc(var(--item-width) - 6px);
  height: calc(var(--item-height) - 6px);
  background-color: var(--white-color-lightest);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  z-index: 0;
  transform: translateX(calc(var(--cursor-index) * (var(--item-width) + 3px)));
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.switch .cursor:hover {
  box-shadow: var(--omni-shadow-hidden);
}
.switch .icon {
  position: relative;
  z-index: var(--z-index-local-over-1);
  color: #555;
  transition: 0.3s;
  pointer-events: none;
}
.switch .icon.inactive {
  color: #ccc;
}
.switch .icon.icon-right {
  padding-left: 1px;
}
.switch .icon.icon-left {
  padding-right: 2px;
}
.switch .button:hover {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Switch.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,gBAAA;AACA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,0CAAA;EAYA,kBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,YAAA;EAmBA,cAAA;AA7BJ;AANI;EACI,0CAAA;EACA,iCAAA;EACA,eAAA;AAQR;AANQ;EACI,8CAAA;AAQZ;AAGI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,sCAAA;EACA,6CAAA;EACA,wCAAA;EACA,kBAAA;EACA,UAAA;EACA,4EAAA;EACA,qDAAA;AADR;AAGQ;EACI,qCAAA;AADZ;AAMI;EACI,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;AAJR;AAMQ;EACI,WAAA;AAJZ;AAOQ;EACI,iBAAA;AALZ;AAOQ;EACI,kBAAA;AALZ;AAUQ;EACI,6BAAA;AARZ","sourcesContent":["/* スイッチ全体のスタイル */\r\n.switch {\r\n    position: relative;\r\n    width: fit-content;\r\n    height: 42px;\r\n    background-color: var(--white-color-light);\r\n\r\n    // 非活性時はTextInputの:disabledと同じ色に揃える\r\n    &.disabled {\r\n        background-color: var(--disabled-bg-color);\r\n        color: var(--disabled-font-color);\r\n        cursor: default;\r\n\r\n        .cursor {\r\n            background-color: var(--disabled-border-color);\r\n        }\r\n    }\r\n    border-radius: 4px;\r\n    padding : 0px 4px;\r\n\r\n    --item-width: 40px;\r\n    --item-height: 40px;\r\n    --cursor-index: 2;\r\n    \r\n    /* 背後のカーソル */\r\n    .cursor {\r\n        position: absolute;\r\n        top: 4px;\r\n        left: 2px;\r\n        width: calc(var(--item-width) - 6px);\r\n        height: calc(var(--item-height) - 6px);\r\n        background-color: var(--white-color-lightest);\r\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\r\n        border-radius: 4px;\r\n        z-index: 0;\r\n        transform: translateX(calc(var(--cursor-index) * (var(--item-width) + 3px)));\r\n        transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n\r\n        &:hover{\r\n            box-shadow: var(--omni-shadow-hidden);\r\n        }\r\n    }\r\n\r\n    /* アイコンのスタイル */\r\n    .icon {\r\n        position: relative;\r\n        z-index: var(--z-index-local-over-1);\r\n        color: #555;\r\n        transition: 0.3s;\r\n        pointer-events: none;\r\n\r\n        &.inactive {\r\n            color: #ccc;\r\n        }\r\n\r\n        &.icon-right{\r\n            padding-left: 1px;\r\n        }\r\n        &.icon-left{\r\n            padding-right: 2px;\r\n        }\r\n    }\r\n\r\n    .button{\r\n        &:hover{\r\n            background-color: transparent;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
